import { Dialog } from "@verde/compose-ui";
import { ChevronLeftIcon, ExclamationTriangleIcon } from "@verde/icons";
import { IconButton } from "@verde/ui-core";
import React, { createElement, useCallback, useEffect, useState } from "react";
import { create } from "zustand";
import AuthorizationDialogAttachment from "./authorization-dialog-attachment";
import AuthorizationDialogSelect from "./authorization-dialog-select";
import authorizationDialogWhatsapp from "./authorization-dialog-whatsapp";
import type { AuthorizationDialogProps, UseAuthorizationDialog } from "./types";

export const AUTHORIZATION_KIND = {
  whatsapp: {
    title: "Enviar link por Whatsapp",
    component: authorizationDialogWhatsapp,
    kind: "warning",
    icon: undefined,
  },
  attachment: {
    title: "Anexar autorização por escrito",
    component: AuthorizationDialogAttachment,
    kind: "warning",
    icon: undefined,
  },
  default: {
    title: "Autorização necessária",
    component: AuthorizationDialogSelect,
    kind: "error",
    icon: <ExclamationTriangleIcon />,
  },
} as const;

export const useAuthorizationDialog = create<UseAuthorizationDialog>((set) => {
  return {
    client: undefined,
    kind: "default",
    setKind: (kind) => {
      set(() => ({ kind }));
    },
    onClose: () => undefined,
  };
});

function AuthorizationDialog({
  client,
  onClose: defaultOnClose,
}: AuthorizationDialogProps) {
  const { kind, setKind } = useAuthorizationDialog();

  const onClose = useCallback(() => {
    setKind("default");
    defaultOnClose?.();
  }, [setKind, defaultOnClose]);

  useEffect(() => {
    useAuthorizationDialog.setState(() => {
      return {
        client,
        onClose,
      };
    });
  }, [client, onClose]);

  return (
    <Dialog
      open
      size="sm"
      onClose={onClose}
      header={{
        size: "lg",
        icon: AUTHORIZATION_KIND[kind]?.icon || (
          <IconButton onClick={() => setKind("default")}>
            <ChevronLeftIcon />
          </IconButton>
        ),
        title: AUTHORIZATION_KIND[kind].title,
        kind: AUTHORIZATION_KIND[kind].kind,
      }}
    >
      {createElement(AUTHORIZATION_KIND[kind].component)}
    </Dialog>
  );
}

export default React.memo(AuthorizationDialog);
